import { render, staticRenderFns } from "./re-image-uploader.vue?vue&type=template&id=16e573f2"
import script from "./re-image-uploader.vue?vue&type=script&lang=ts"
export * from "./re-image-uploader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports